<template>
  <div class="mb-3">
    <v-tabs
      slot="extension"
      v-model="currentTab"
      centered
      color="secondary"
      slider-color="orange"
    >
      <v-tab href="#tabCurrent">
        Current
      </v-tab>
      <v-tab href="#tabHistory">
        History
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentTab">
      <v-tab-item id="tabCurrent">
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-if="!defs.isSelectAllGroups"
              v-model="search"
              append-icon="search"
              label="Filter Groups"
              single-line
              hide-details
            />
            <v-data-table
              :headers="groupTableHeaders"
              :items="defs.Active"
              :search="search"
              class="elevation-1"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item="props">
                <tr v-show="defs.isSelectAllGroups === (props.item.userGroupTypeCode === 'ALL_TRACKING_GROUPS')">
                  <td class="justify-center">
                    <v-btn
                      v-show="props.item.userGroupTypeCode !== 'ALL_TRACKING_GROUPS'"
                      icon
                      class="mx-0"
                      @click="$emit('delete', props.item)"
                    >
                      <v-icon color="error">delete</v-icon>
                    </v-btn>
                  </td>
                  <td><GroupTrackClient :type="props.item.userGroupTypeCode" :value2="props.item.userGroupTypeValue2" /></td>
                  <td>{{ props.item.userGroupTypeValue }}</td>
                  <td>{{ props.item.createdBy }}</td>
                  <td>{{ props.item.createdOn | formatDate }}</td>
                  <td>{{ props.item.lastModifiedBy }}</td>
                  <td>{{ props.item.lastModifiedOn | formatDate }}</td>
                  <td :class="props.item.actionTypeCode === 'I' ? 'included-item' : 'excluded-item'">
                    {{ props.item.actionTypeCode === 'I' ? 'Included' : 'Excluded' }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item id="tabHistory">
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filter Groups"
              single-line
              hide-details
            />
            <v-data-table
              :headers="groupTableHistoryHeaders"
              :items="defs.Inactive"
              :search="search"
              class="elevation-1"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item="props">
                <tr>
                  <td><GroupTrackClient :type="props.item.userGroupTypeCode" :value2="props.item.userGroupTypeValue2" /></td>
                  <td>{{ props.item.userGroupTypeValue }}</td>
                  <td>{{ props.item.createdBy }}</td>
                  <td>{{ props.item.createdOn | formatDate }}</td>
                  <td>{{ props.item.lastModifiedBy }}</td>
                  <td>{{ props.item.lastModifiedOn | formatDate }}</td>
                  <td :class="props.item.actionTypeCode === 'I' ? 'included-item' : 'excluded-item'">
                    {{ props.item.actionTypeCode === 'I' ? 'Included' : 'Excluded' }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import GroupTrackClient from './GroupTrackClient'
export default {
  name: 'manage-user-groups-modal-table',
  components: {
    GroupTrackClient
  },
  props: {
    defs: Object
  },
  data() {
    return {
      currentTab: 'tabCurrent',
      search: '',
      selectedUserGroup: {},
      groupTableHeaders: [{
        text: 'Action',
        value: false,
        sortable: false
      },
      {
        text: 'Level',
        value: 'userGroupTypeCode'
      },
      {
        text: 'ID Name',
        value: 'userGroupTypeValue'
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Modified By',
        value: 'lastModifiedBy'
      },
      {
        text: 'Modified On',
        value: 'lastModifiedOn'
      },
      {
        text: 'Item Type',
        value: 'actionTypeCode'
      }
      ],
      groupTableHistoryHeaders: [{
        text: 'Level',
        value: 'userGroupTypeCode'
      },
      {
        text: 'ID Name',
        value: 'userGroupTypeValue'
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Modified By',
        value: 'lastModifiedBy'
      },
      {
        text: 'Modified On',
        value: 'lastModifiedOn'
      },
      {
        text: 'Item Type',
        value: 'actionTypeCode'
      }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .included-item {
    color: $color-success;
  }
  .excluded-item{
    color: $color-danger
  }
</style>
